"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Account_Billing = void 0;

var Billing_Form = void 0;
var get_parameter_by_name = void 0;
var noun_user = void 0;
var url_to_array = void 0;

Billing_Form = require("./billing_form").default;

get_parameter_by_name = require("../helpers/get_parameter_by_name").default;

noun_user = require("../helpers/noun_user").default;

url_to_array = require("../helpers/url_to_array").default;

Account_Billing = function () {
  function Account_Billing() {
    var $card_cvc = void 0;
    var $card_number = void 0;
    var $plansForm = void 0;
    var deleteCardUrl = void 0;
    var update_billing_editable = void 0;
    $plansForm = null;
    $card_number = (0, _jquery2.default)("#card-number");
    $card_cvc = (0, _jquery2.default)("#card-cvc");
    deleteCardUrl = "//" + url_to_array[2] + "/" + noun_user.username + "/card/delete/";
    update_billing_editable = function update_billing_editable() {
      var $inputs = void 0;
      $inputs = (0, _jquery2.default)("#plans-form :input");
      $inputs.prop("disabled", "");
      (0, _jquery2.default)(".settings-save").removeClass("disabled");
      (0, _jquery2.default)(".delete-card-container").show();
      $card_number.val("");
      $card_cvc.val("");
      return $card_number.focus();
    };
    (0, _jquery2.default)("#update-billing").on("click", function (e) {
      e.preventDefault();
      return update_billing_editable();
    });
    (0, _jquery2.default)(".delete-card-link").on("click", function (e) {
      var delLink = void 0;
      var delLinkCont = void 0;
      e.preventDefault();
      delLink = (0, _jquery2.default)(this);
      delLinkCont = delLink.parents(".delete-card-container");
      if (delLink.hasClass("confirm")) {
        return _jquery2.default.ajax({
          url: deleteCardUrl,
          type: "POST",
          success: function success(_ref, status, xhr) {
            var ok = _ref.ok;

            if (ok === true) {
              delLink.fadeOut();
              $plansForm.reset_form();
              return (0, _jquery2.default)("<p>").appendTo(delLinkCont).text(delLinkCont.data("successMsg"));
            }
          },
          error: function error(xhr, status, _error) {

            return console.log(_error);
          }
        });
      } else {
        delLink.text("Permanently delete card");
        return delLink.addClass("confirm");
      }
    });
    (0, _jquery2.default)(document).ready(function () {
      $plansForm = new Billing_Form((0, _jquery2.default)("#plans-form"), "update");
      if (get_parameter_by_name("update") === "true") {
        return update_billing_editable();
      }
    });
  }

  return Account_Billing;
}();

exports.default = Account_Billing;